<template>
  <cargo-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :title="this.$t('CargoMsg.Cargo_WriteOffDetails')"
    width="1200px"
    class="app-main-inner write-off-detail-dialog"
    :can-maximize="true"
    :can-minimize="true"
    @fullscreen="p=>{isMax = p}"
    @close="cancel"
  >
    <div class="tabs-container">
      <el-tabs :active-name="activeTabName" @tab-click="handleClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_WriteOff')" name="applicationForm">
          <div class="app-main-inner-row row-grid" :style="isMax ?'width:100%;height:100%' : 'width:100%;height:320px'">
            <cargo-ag-grid
              config-module="180601"
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="finalColumnDefs"
              :row-data="rowData"
              :row-clicked="rowClicked"
            />
          </div>
          <div class="app-main-inner-row" :style="isMax ?'height:30%' : 'height:180px'">
            <el-form :inline="true" disabled :label-width="$selectByLang('65px', '80px')" label-position="left">
              <div class="el-form-item-wrapper">
                <el-form-item>
                  <line-label slot="label" :label="receiveTypeLabel" />
                  <cargo-advance-select
                    filterable
                    no="1"
                    :select-type="selectTypeNames.local_cache_ClearingConstants$AMOUNT_RECEIVE_TYPES"
                    callback-method-type="value"
                    :default-value="type"
                    :callback-params="{key:'receiveType'}"
                    :clearable="false"
                    style="width: 120px;"
                    @parentCallBack="getReceiveTypesFromChild"
                  />
                </el-form-item>
                <el-form-item>
                  <line-label slot="label" :label="$t('WriteOff.bankReceiptStatus')" />
                  <cargo-advance-select
                    filterable
                    no="2"
                    :default-value="cashTransferState"
                    :static-options="cashTransferStateArray"
                    tag-value="code"
                    style="width: 120px;"
                    @parentCallBack="getCashTransferStateFromChild"
                  />
                </el-form-item>
                <el-form-item>
                  <line-label slot="label" :label="$t('WriteOff.ourSideBank')" />
                  <el-select no="3" :value="ourBankValue" style="width: 150px;" />
                </el-form-item>
                <el-form-item>
                  <line-label slot="label" :label="$t('WriteOff.ourSideAccount')" />
                  <el-input
                    v-model="ourBankAccountNo"
                    no="4"
                    style="width: 160px;"
                  />
                </el-form-item>
                <el-form-item>
                  <line-label slot="label" :label="$t('WriteOff.proofNo')" />
                  <el-input
                    v-model="voucherNo"
                    no="5"
                    style="width: 150px;"
                  />
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('WriteOff.currency')">
                  <cargo-advance-select
                    filterable
                    no="6"
                    :select-type="selectTypeNames.basic_data_Currency"
                    :default-value="currency"
                    :clearable="false"
                    style="width: 120px;"
                  />
                </el-form-item>
                <el-form-item class="custom-el-form-item-color-red">
                  <line-label slot="label" :label="amountLabel" />
                  <!--                  <el-input-number-->
                  <!--                    v-model="verfiedAmount"-->
                  <!--                    no="7"-->
                  <!--                    controls-position="right"-->
                  <!--                    :precision="2"-->
                  <!--                    style="width: 120px;"-->
                  <!--                  />-->
                  <el-input
                    :value="formatVerfiedAmount"
                    no="7"
                    style="width: 120px;"
                  />
                </el-form-item>
                <el-form-item>
                  <line-label slot="label" :label="$t('WriteOff.theOppositeSideCompany')" />
                  <el-input
                    v-model="paymentCompany"
                    no="8"
                    style="width: 150px;"
                  />
                </el-form-item>
                <el-form-item>
                  <line-label slot="label" :label="$t('WriteOff.theOppositeSideBank')" />
                  <el-input
                    v-model="companyBank"
                    no="9"
                    style="width: 160px;"
                  />
                </el-form-item>
                <el-form-item>
                  <line-label slot="label" :label="$t('WriteOff.theOppositeSideAccount')" />
                  <el-input
                    v-model="companyBankAccount"
                    no="10"
                    style="width: 150px;"
                  />
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <!--汇兑损益-->
                <el-form-item class="custom-el-form-item-color-green">
                  <line-label slot="label" :label="$t('WriteOff.exchangeGainsAndLosses')" />
                  <el-input-number
                    v-model="nsDiffChange"
                    no="11"
                    controls-position="right"
                    :precision="2"
                    style="width: 120px;"
                  />
                </el-form-item>
                <!--财务费用-->
                <el-form-item class="custom-el-form-item-color-green">
                  <line-label slot="label" :label="$t('WriteOff.financialCharges')" />
                  <el-input-number
                    v-model="nsFinancialCost"
                    no="12"
                    controls-position="right"
                    :precision="2"
                    style="width: 120px;"
                  />
                </el-form-item>
                <!--零头短账-->
                <el-form-item :label="$t('WriteOff.oddment')" class="custom-el-form-item-color-green">
                  <el-input-number
                    v-model="nsClearOdd"
                    no="13"
                    controls-position="right"
                    :precision="2"
                    style="width: 120px;"
                  />
                </el-form-item>
                <!--销账备注-->
                <el-form-item :label="$t('WriteOff.remark')" class="custom-el-form-item-color-green remark">
                  <cargo-rich-textarea
                    v-model="remark"
                    no="14"
                    :text-chars="0"
                    :warning-count="-1"
                    :disabled="true"
                    :single-line="true"
                    @dblclick.native="showAdvanceTextDialog($t('WriteOff.remark'), remark)"
                  />
                </el-form-item>
                <!--预收付备注-->
                <el-form-item>
                  <line-label slot="label" :label="$t('Payment.preRemarks')" />
                  <el-input
                    v-model="preRemark"
                    no="5"
                    style="width: 150px;"
                  />
                </el-form-item>
                <el-form-item>
                  <line-label slot="label" :label="$t('CargoMsg.Cargo_WriteOffHeader')" />
                  <el-input
                    v-model="actualAmountTitle"
                    no="actualAmountTitle"
                    style="width: 150px;"
                  />
                </el-form-item>
                <el-form-item>
                  <span style="color: #1a61af;font-weight: bold;">{{ $t('WriteOff.thisTimeWriteOff')+'='+amountLabel+'+'+$t('WriteOff.exchangeGainsAndLosses')+'+'+$t('WriteOff.financialCharges')+'+'+$t('WriteOff.oddment') }}</span>
                </el-form-item>
              </div>
              <div v-if="showWhtAmount" class="el-form-item-wrapper">
                <el-form-item>
                  <span>{{ $t('Clearing.WhtDeductionAmount') }}</span>
                  <el-input :value="whtAmount.toFixed(2)" disabled style="width: 120px;margin-left: 10px" />
                </el-form-item>
              </div>
            </el-form>
          </div>
        </el-tab-pane>
        <!--v-if="selectedRowMode === 5" -->
        <el-tab-pane :label="$t('CargoMsg.Cargo_FileHistory')" name="fileHistory" :lazy="true" style="height: 503px;">
          <file-history v-if="actualAmount && actualAmount.uuid" :uuid="actualAmount.uuid" :state="0" :input-by="$store.getters.userId" grid-height="416px" module-name="writeOff" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <div slot="footer">
      <span style="position: absolute; left: 0; padding-left: 10px;">
        <span>{{ $t('WriteOff.totalWriteOffs') }}</span>
        <charge-currency-total-group
          ar-field="ar"
          currency-field="clearCurrency"
          data-field="clearAmount"
          type="revenueAbs"
          :data-provider="totalGroup"
          :amount-to-currency-label="$t('WriteOff.totalWriteOffs')"
        />
        <span>{{ $t('WriteOff.totalEquivalent') }}</span>
        <charge-currency-total-group
          v-if="reCalc"
          ar-field="ar"
          currency-field="currency"
          data-field="amount"
          :amount-to-currency="localCurrency"
          rate-field="rate"
          type="revenueAbs"
          :amount-to-currency-label="$t('Clearing.Equivalent')"
          :data-provider="totalGroup2"
        />
      </span>
      <span>
        <el-button-group>
          <el-button v-show="activeTabName==='applicationForm'" v-permission="['button_ACWriteoff_approve']" type="primary" no="15" @click="approveHandler">{{ $t('WriteOff.recheck') }}</el-button>
          <!--导出Excel-->
          <el-button v-show="activeTabName==='applicationForm'" type="primary" no="16" @click="onExport"><svg-icon icon-class="excel" style="font-size: 12px;vertical-align: bottom" />{{ $t('WriteOff.exportToExcel') }}</el-button>
          <!--导出PDF-->
          <el-button v-show="activeTabName==='applicationForm'" type="primary" no="17" @click="onExportPdf"><svg-icon icon-class="excel" style="font-size: 12px;vertical-align: bottom" />{{ $t('WriteOff.exportPDF') }}</el-button>
          <!--打印-->
          <el-button v-show="activeTabName==='applicationForm'" type="primary" no="18" @click="onPrint">{{ $t('WriteOff.print') }}</el-button>
          <el-button no="19" @click="cancel">{{ $t('WriteOff.close') }}</el-button>
        </el-button-group>
      </span>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />

    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceTextDialog"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :append-to-body="true"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        no="advanceTextDialogTextarea"
        :disabled="true"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-half-word="advanceTextDialog.formatObj.autoHalfWord"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          no="advanceTextDialogClose"
          @click="advanceTextDialog.visible=false;"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>

  </cargo-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import * as writeoffApi from '@/api/act/writeoff'
import { getBankAccountList } from '@/api/bankAccount'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth'
import lodash from 'lodash'
import { exportExcel } from '@/utils/tableDataExportUtils'
import { roundHalfUp, multiply } from '@/utils/commonUtil'
import fileHistory from '@/views/cargo/v0/Clearing/components/BillPayment/fileHistory'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import * as NumberUtils from '@/utils/NumberUtils'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea.vue'
import specialCharacterTip from '@/components/Cargo/Common/specialCharacterTip.vue'
import { formatNumberToThousands } from '@/utils'

export default {
  name: 'WriteOffDetailDialog',
  components: {
    specialCharacterTip,
    cargoRichTextarea, CargoAdvanceSelect, ChargeCurrencyTotalGroup, cargoTemplateSelectorDialog, fileHistory, CargoDialog },
  props: {
    visible: { type: Boolean, required: true },
    params: { type: Object, required: true }
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      ourBankValue: '',
      totalGroup: null,
      totalGroup2: null,
      amountLabel: this.$t('Clearing.PaymentAmount'),
      clickRow: null,
      receiveTypeLabel: this.$t('Clearing.PaymentMethod'),
      ourBankAccountId: null,
      ourBankAccountNo: '',
      type: 2,
      cashTransferState: 0,
      voucherNo: '',
      currency: '',
      verfiedAmount: 0,
      paymentCompany: '',
      companyBank: '',
      companyBankAccount: '',
      remark: '',
      preRemark: '',
      actualAmountTitle: '',
      bankAccounts: null,
      amountDebit: null,
      clearAmountDebit: null,
      amountCredit: null,
      clearAmountCredit: null,
      nsClearOdd: null,
      nsDiffChange: null,
      nsFinancialCost: null,
      actualAmount: null,
      receiveTypeArray: [],
      cashTransferStateArray: [],
      selectTypeNames: TYPE_NAMES,
      url: URL,
      loading: false,
      innerVisible: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: false
        },
        pagination: false
      },
      columnDefs: [
        {
          headerName: this.$t('WriteOff.businessNumber'),
          field: 'jobNo',
          colId: 'jobNo',
          width: 140
        }, {
          headerName: this.$t('WriteOff.mbl'),
          field: 'mbl',
          colId: 'mbl',
          width: 140
        }, {
          headerName: this.$t('WriteOff.separateNumber'),
          field: 'hbl',
          colId: 'hbl',
          width: 140
        }, {
          headerName: this.$t('WriteOff.writeOffSerialNumber'),
          field: 'actualAmountNo',
          colId: 'actualAmountNo',
          width: 140,
          hide: true
        }, {
          headerName: this.$t('WriteOff.consignationCompany'),
          field: 'customerId',
          colId: 'customerId',
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.settleAccountsTo'),
          field: 'accountId',
          colId: 'accountId',
          width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.vesselVoyage'),
          field: 'vesselFlight',
          colId: 'vesselFlight',
          width: 140
        }, {
          headerName: this.$t('WriteOff.containerSizeAmount'),
          field: 'containerDesc',
          colId: 'containerDesc',
          width: 140
        }, {
          headerName: this.$t('WriteOff.businessDate'),
          field: 'businessDate',
          colId: 'businessDate',
          width: 100,
          cellRenderer: (params) => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('WriteOff.chargeItem'),
          field: 'chargeItemId',
          colId: 'chargeItemId',
          width: 100,
          cellRenderer: (params) => {
            return this.chargeNameLabelFun(params.data, params.value)
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('WriteOff.revenueAndExpenditureType'),
          field: 'ar',
          colId: 'ar',
          width: 100,
          cellRenderer: (params) => {
            return params.value ? this.$t('Message.Receivable') : this.$t('Message.Payable')
          }
        }, {
          headerName: this.$t('WriteOff.writeOffCurrency'),
          field: 'clearCurrency',
          colId: 'clearCurrency',
          width: 100
        }, {
          headerName: this.$t('WriteOff.theAmountOfWriteOffs'),
          field: 'clearAmount',
          colId: 'clearAmount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(Number(params.value), 2)
          }
        }, {
          headerName: this.$t('WriteOff.writeOffExchangeRate'),
          field: 'clearRate',
          colId: 'clearRate',
          width: 100,
          cellRenderer: (params) => {
            return Number(params.value).toFixed(8)
          }
        }, {
          headerName: this.$t('WriteOff.chargeOriginalCurrency'),
          field: 'currency',
          colId: 'currency',
          width: 100
        }, {
          headerName: this.$t('WriteOff.chargeOriginalAmount'),
          field: 'amount',
          colId: 'amount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(Number(params.value).toFixed(2), 2)
          }
        }, {
          headerName: this.$t('WriteOff.chargeOriginalExchangeRate'),
          field: 'rate',
          colId: 'rate',
          width: 100,
          cellRenderer: (params) => {
            return Number(params.value).toFixed(8)
          }
        }, {
          headerName: this.$t('WriteOff.monetaryEquivalent'),
          field: 'convertAmount',
          colId: 'convertAmount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(Number(params.value).toFixed(2), 2)
          }
        }, {
          headerName: this.$t('WriteOff.ChargeOriginTotalAmount'),
          field: 'chargeAmount',
          colId: 'chargeAmount',
          width: 100,
          cellRenderer: (params) => {
            return formatNumberToThousands(Number(params.value).toFixed(2), 2)
          }
        }, {
          headerName: 'ETD',
          field: 'ETD',
          width: 90,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: 'ETA',
          field: 'ETA',
          width: 90,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: 'ATD',
          field: 'ATD',
          width: 90,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: 'ATA',
          field: 'ATA',
          width: 90,
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('WriteOff.invoiceNo'),
          field: 'invoiceNo',
          colId: 'invoiceNo',
          width: 100
        }, {
          headerName: this.$t('WriteOff.sales'),
          field: 'sales',
          colId: 'sales',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.operation'),
          field: 'op',
          colId: 'op',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.customerService'),
          field: 'csr',
          colId: 'csr',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.ourSideBank'),
          field: 'ourBank',
          colId: 'ourBank',
          width: 100,
          cellRenderer: (params) => {
            return this.queryOurBankLabelFunc(params.data)
          },
          filter: false,
          filterParams: {}
        }, {
          headerName: this.$t('WriteOff.invoiceDate'),
          field: 'invoiceDate',
          colId: 'invoiceDate',
          width: 100,
          cellRenderer: (params) => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('WriteOff.warehouseNo'),
          field: 'warehouseNo',
          colId: 'warehouseNo',
          width: 100,
          hide: true
        }, {
          headerName: this.$t('WriteOff.writeOffPerson'),
          field: 'verificationBy',
          colId: 'verificationBy',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('WriteOff.writeOffDate'),
          field: 'verificationDate',
          colId: 'verificationDate',
          width: 100,
          cellRenderer: (params) => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('WriteOff.revenueAndExpenditureDate'),
          field: 'payReceiveDate',
          colId: 'payReceiveDate',
          width: 100,
          cellRenderer: (params) => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ApprovedBy'),
          field: 'approvedBy',
          colId: 'approvedBy',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_RecheckDate'),
          field: 'dateApproved',
          colId: 'dateApproved',
          width: 100,
          cellRenderer: (params) => {
            return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
          }
        }, {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          field: 'invoiceTitle',
          colId: 'invoiceTitle',
          hide: true,
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_WriteOffHeader'),
          field: 'actualAmountTitle',
          colId: 'actualAmountTitle',
          width: 120
        },
        {
          headerName: this.$t('Payment.chargeRemark'),
          field: 'remarks',
          colId: 'remarks',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.BusinessReferenceNo'),
          colId: 'customerRefNo',
          field: 'customerRefNo',
          width: 200,
          hide: true
        }
      ],
      whtColumnDefs: [
        {
          headerName: this.$t('FinanceManage.charge_whtTaxRate'), field: 'whtTaxRate', width: 100,
          valueFormatter: (params) => {
            return Number(params.value).toFixed(2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxLocalAmount'), field: 'whtTaxLocalAmount', width: 150,
          valueFormatter: (params) => {
            return Number(params.value).toFixed(2)
          }
        }
      ],
      rowData: [],
      templateSelectorDialog: {// 模板选择弹窗
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      activeTabName: 'applicationForm', // 当前展示页签
      isMax: false,
      showWhtAmount: false,
      whtAmount: 0,
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoHalfWord: false,
          autoUppercase: false
        }
      }
    }
  },
  computed: {
    finalColumnDefs() {
      if (this.showWhtAmount) {
        return [...this.columnDefs, ...this.whtColumnDefs]
      }
      return this.columnDefs
    },
    formatVerfiedAmount() {
      return formatNumberToThousands(this.verfiedAmount, 2).toString()
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      if (!newVal) {
        this.clearHandler()
        this.$emit('update:visible', newVal)
        this.activeTabName = 'applicationForm'
      } else {
        this.actualAmount = this.params.actualAmount
        // Cannot read property of null
        this.type = this.actualAmount.type
        this.cashTransferState = this.actualAmount.cashTransferState
        this.voucherNo = this.actualAmount.voucherNo
        this.currency = this.actualAmount.currency
        this.verfiedAmount = this.actualAmount.verfiedAmount
        this.paymentCompany = this.actualAmount.paymentCompany
        this.companyBank = this.actualAmount.companyBank
        this.companyBankAccount = this.actualAmount.companyBankAccount
        this.remark = this.actualAmount.remark
        this.preRemark = this.actualAmount.preRemark
        this.actualAmountTitle = this.actualAmount.actualAmountTitle || ''
        this.startLoad()
        const ourBankAccount = this.bankAccounts.find(param => { return param.accountNo === this.actualAmount.ourBankAccount && param.currency === this.actualAmount.ourBankCurrency })
        if (ourBankAccount) {
          this.ourBankValue = '[' + ourBankAccount.code + ']' + '[' + ourBankAccount.currency + ']' + ourBankAccount.bankChineseName
          this.ourBankAccountNo = ourBankAccount.accountNo
        } else {
          this.ourBankValue = ''
          this.ourBankAccountNo = ''
        }
      }
    }
  },
  async created() {
    // 初始化收付类型
    // for (const value of AMOUNT_RECEIVE_TYPES.values()) {
    //   this.receiveTypeArray.push(value)
    // }
    // 初始化银行账号
    this.bankAccounts = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => {
      return res.data
    })
    // 初始化水单状态
    if (this.cashTransferStateArray.length === 0) {
      const CASH_TRANSFER_WSY = { code: 0, englishName: 'WSY', chineseName: '未使用' }
      const CASH_TRANSFER_GSD = { code: 1, englishName: 'GSD', chineseName: '挂水单' }
      const CASH_TRANSFER_SDK = { code: 2, englishName: 'SDK', chineseName: '收到款' }
      const CASH_TRANSFER_NDHD = { code: 3, englishName: 'NDHD', chineseName: '拿到回单' }
      this.cashTransferStateArray = [CASH_TRANSFER_WSY, CASH_TRANSFER_GSD, CASH_TRANSFER_SDK, CASH_TRANSFER_NDHD]
    }
    this.setLocalCurrency()
  },
  methods: {// todo 收付款金额框、点击切换收/付款错误、打印验证
    chargeNameLabelFun(data, value) {
      const chargeItem = ChargeItem.getChargeItemById(value)
      if (chargeItem) {
        return this.$store.getters.language === 'zh' ? chargeItem.zhName : chargeItem.enName
      }
      return ''
    },
    getReceiveTypesFromChild(data) {
      this.form.type = data.type
    },
    getCashTransferStateFromChild(data) {
      this.actualAmount.cashTransferState = data.cashTransferState
    },
    getOurBankAccountFromChild(data) {
      this.ourBankAccountId = data.accountId
      this.ourBankAccountNo = data.accountNo
      this.form.ourBank = data.bankChineseName
      this.form.ourBankAccount = data.accountNo
      this.form.ourBankCurrency = data.currency || ''
    },
    cancel() {
      this.innerVisible = false
      if (this.destroySelf) {
        this.destroySelf()
      }
    },
    startLoad() {
      writeoffApi.queryActualAmountsByID([this.actualAmount.uuid]).then(res => {
        const rowData = res.data
        this.showWhtAmount = this.$store.getters.currentOffice.whtTaxMode
        this.whtAmount = 0
        for (const obj of rowData) {
          obj.convertAmount = roundHalfUp(multiply(obj.amount, obj.rate), 2)
          this.nsClearOdd = obj.clearOdd
          this.nsDiffChange = obj.diffChange
          this.nsFinancialCost = obj.financialCost

          if (obj.ar) {
            this.amountDebit = obj.amount
            this.clearAmountDebit = obj.clearAmount
          } else {
            this.amountCredit = obj.amount
            this.clearAmountCredit = obj.clearAmount
          }
          if (this.showWhtAmount && obj.amount !== obj.chargeAmount) {
            this.showWhtAmount = false
          }
          this.whtAmount += obj.whtTaxLocalAmount
        }
        this.whtAmount = NumberUtils.ToFixed2(this.whtAmount, 2)
        this.rowData = rowData
        this.totalGroup = this.totalGroup2 = rowData

        // 默认选中第一个
        if (this.rowData[0]) {
          const data = this.rowData[0]
          this.rowClicked({ data })
        }
      }).catch(err => {
        this.faultHandler()
      })
    },
    faultHandler() {
      this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
    },
    queryOurBankLabelFunc(data) {
      let text = data.ourBank
      if (data.ourBank === '' || data.ourBank === null) {
        for (const bankAccount of this.bankAccounts) {
          if (bankAccount.accountNo === data.ourBankAccount && bankAccount.currency === data.currency) {
            text = bankAccount.bankChineseName
            break
          }
        }
      }
      return text
    },
    rowClicked(event) {
      this.clickRow = event.data
      this.receiveTypeLabel = (this.clickRow.ar ? this.$t('Payment.receipt') : this.$t('Payment.payment')) + this.$t('WriteOff.method')
      this.amountLabel = this.clickRow.ar ? this.$t('WriteOff.receiptAmount') : this.$t('WriteOff.paymentAmount')
    },
    clearHandler() {
      this.ourBankAccountId = null
      this.ourBankAccountNo = ''
      this.actualAmountTitle = ''
    },
    // 复核
    approveHandler() {
      this.params.view.approveHandler(this.actualAmount)
    },
    // 导出Pdf
    onExportPdf() {
      const queryResult = lodash.cloneDeep(this.rowData)
      if (queryResult && queryResult.length > 0) {
        const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
        // 表头
        const headers = []
        let field
        let headerName
        for (const column of allDisplayedColumns) {
          field = column.colDef.field
          headerName = column.colDef.headerName
          headers.push({ field, headerName })
        }
        // 数据渲染
        for (const item of queryResult) {
          for (const column of allDisplayedColumns) {
            const colDef = column.colDef
            const dataField = colDef.field
            // 进行labelFunction 处理
            if (colDef.cellRenderer && typeof colDef.cellRenderer !== 'string') {
              const params = { data: item, value: item[dataField] }
              item[dataField] = colDef.cellRenderer(params)
            }
          }
        }
        // form表单请求
        const url = URL.report.exportPdf + '?sessionId=' + getToken()
        const params = {}
        params.tableHeader = JSON.stringify(headers)
        params.tableBody = JSON.stringify(queryResult)
        this.navigateToURL(url, params)
      } else {
        this.$message.info(this.$t('CargoMsg.Cargo_NoData'))
      }
    },
    // 导出Excel
    async onExport() {
      const queryResult = this.rowData
      if (queryResult && queryResult.length > 0) {
        await this.$confirm(this.$t('CargoMsg.Cargo_LoadedAndSave'))
        this.exportHandler(queryResult)
      } else {
        this.$message.info(this.$t('CargoMsg.Cargo_NoData'))
      }
    },
    // 导出excel操作处理器
    exportHandler(rows) {
      const self = this
      if (!rows || rows.length === 0) {
        self.$message.warning(this.$t('CargoMsg.Cargo_NoData'))
        return
      }
      const timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      // 获取选中行
      const fileName = this.$t('CargoMsg.Cargo_DetailsOfSingleWriteOffXLS') // '单笔销账明细.xls'
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      exportExcel(fileName, rows, allDisplayedColumns, true)
    },
    async onPrint() {
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToPrintDetailList'))
      const param = {}
      param.ACT_ACTUAL_AMOUNT_UUID = this.actualAmount.uuid
      this.templateSelectorDialog.data = param
      this.templateSelectorDialog.category = 'WRITEOFFDETAILS'
      this.templateSelectorDialog.visible = true
      // TemplateSelectorWin.getInstance().showThisWin(null, "WRITEOFFDETAILS", {ACT_ACTUAL_AMOUNT_UUID : _actualAmount.key}, this);
    },
    // form表单请求方法
    navigateToURL(URL, PARAMS) {
      const form = document.createElement('form')
      form.action = URL
      form.method = 'post'
      form.style.display = 'none'
      for (const key in PARAMS) {
        const opt = document.createElement('textarea')
        opt.name = key
        opt.value = PARAMS[key]
        form.appendChild(opt)
      }
      form.target = '_blank'
      document.body.appendChild(form)
      form.submit()
    },
    // tab 页签点击事件
    handleClick(tab, event) {
      this.activeTabName = tab.name
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    showAdvanceTextDialog(title, value) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.visible = true
    }
  }
}
</script>

<style lang="scss">
.write-off-detail-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
  .custom-el-form-item-color-red {
    .el-form-item__label {
      color: #990000;
    }
    .el-form-item__content {
      .el-input input {
        color: #990000;
      }
    }
  }
  .custom-el-form-item-color-green {
    .el-form-item__label {
      color: #009900;
    }
    .el-form-item__content {
      .el-input input {
        color: #009900;
      }
    }
  }

  .custom-el-form-item-color-green.remark {
    margin-left: 30px;
  }

  .cargo-rich-textarea.quill-editor .ql-container{
    width: 160px;
    height: 28px;
    border-radius: 2px;
  }
}
</style>
